<template>
  <div
    class="w-[25rem]  bg-white absolute top-6 left-0 border rounded-lg shadow-lg overflow-hidden"
  >
    <!--start top section  -->
    <div class="flex justify-between items-center h-12 px-2 bg-red-700 text-white"
    >
      <div class="public-text">
        <span>{{digitsEnToFa( quantityCart) }}</span>
        کالا
      </div>
      <router-link to="/cart"
        type="text"
        class="hover:text-yellow-300 transition-colors duration-75 public-text" 
      >
        مشاهده سبد خرید
      </router-link>
    </div>
    <!--end top section  -->

    <!-- start cart-item  -->
    <div class="max-h-[26rem]  overflow-y-auto shadow-blue-100 shadow-sm ">
        <ul>
          <li v-for="(item,index) in cartItems" :key="index" >
            <div class="flex shadow-blue-100 shadow-sm    ">
        <div class="w-[40%] flex flex-col items-center justify-center pt-2">
          <img  :src="'https://parsinekala.com' + item.product.images[0].image"
               :alt="item.product.slug" class="w-24 h-36" />

          <!-- add or remove btn section -->
          <div class="w-28 h-10 rounded-md border-2 border-red-500 text-red-700 flex items-center justify-evenly my-2">
            <div @click="minus(item.id, item.quantity, index)">
              
              <font-awesome-icon icon="trash" class="hover:text-blue-800 cursor-pointer w-4 h-4" v-if="item.quantity === 1 || item.variation.inventory === 0" />
              <span v-else-if="loading[index].minus" class="inline-block  border-gray-300 h-4 w-4 animate-spin rounded-full border-4 hover:text-blue-800 border-t-blue-600" />
              <font-awesome-icon icon="minus" v-else class=" cursor-pointer hover:text-blue-800" />
            </div>
            <div class="border-l border-r h-10 w-10 flex flex-col items-center justify-center" >
              <span class="font-IRANSansFa text-sm font-bold">{{ item.quantity }}</span>
              <span class="text-xs public-text1"  v-if="item.quantity === item.variation.inventory && item.variation.inventory !== 0">حداکثر</span>
            </div>
            <span v-if="!loading[index].plus " class="hover:text-blue-800">
              <font-awesome-icon icon="plus" @click="plus(item.id, item.quantity, item.variation.inventory, index)" class="cursor-pointer " />
            </span>
            <span v-else class="inline-block  border-gray-300 h-4 w-4 animate-spin rounded-full border-4 border-t-blue-600" />
          </div>
          <!-- end add or remove btn section -->
        </div>
        <div class="w-[60%] text-gray-700 ">
          <h3 class="h-12 mt-4 public-text-b "> {{ item.product.name }} </h3>
          <p class="mb-2 public-text1 ">رنگ : <span class="inline-block ml-1 text-gray-500">{{ item.variation.color }}</span></p>
          <p class="mb-2 public-text1 ">سایز : <span class="inline-block text-gray-500 ml-1">{{ item.variation.size}}</span></p>
          <p v-if="item.variation.inventory" class="mb-2 public-text1" aria-label="موجودی محصول">
            {{ digitsEnToFa(item.variation.inventory)}}
            <span class="text-gray-500 ml-1">عدد موجود در انبار</span>
          </p>
          <p v-else aria-label="موجودی محصول" class="mb-2 public-text1 text-red-500" >
              در انبار موجود نیست
            </p>
  
          <p class="public-text1 text-gray-500">{{digitsEnToFa(formatNumber(item.total_price)) }} تومان</p>
        </div>
      </div>
          </li>
        </ul>
    </div>
    <!-- end cart-item  -->

    <!--  start record order section  -->
    <div class="flex items-center justify-between px-2 my-4 public-text1-b">
      <div>
        <h3>مبلغ قابل پرداخت</h3>
        <span>{{ digitsEnToFa(total_price) }} تومان</span>
      </div>
      <router-link
        to="/checkout"
        class="px-4 py-2 rounded-lg bg-gradient-to-r from-teal-400 to-blue-500 hover:from-pink-500 hover:to-orange-500 transition-all duration-200 text-white  cursor-pointer"
        >ثبت سفارش</router-link
      >
    </div>
    <!--  end record order section  -->
  </div>
</template>
<script setup>
import {computed,ref} from 'vue'
import axios from 'axios'
import { digitsEnToFa } from "persian-tools";
import { useCartStore } from '@/store/cart';
const card_item=useCartStore();
const cartItems = computed(() => card_item.getCardItem);

const total_price = computed(() => card_item.getTotalPrice);
const quantityCart = computed(() => card_item.getQuantityCart);

    // formatNumber use each tree digit ","
    const formatNumber = (number) => {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '،');
    };

 //seve data in localStorage('set_item')
const addLocalStorageCartItem = async () => {
  await card_item.arrayQuantity();
};

// loading qty should product Qty
const loading = ref([]);
for (let i = 0; i < 100; i++) {
  loading.value[i] = { plus: false, minus: false };
}


// added by farshid
const getNewCartId = async (e) => {
  if (
        e.response.status == 404 ||
        (e.response.status == 400 &&
          e.response.data.detail == "No cart with this id!")
      ) {
        try {
          let req = await axios.post("https://parsinekala.com/backend/api/carts/");
          let id = req.id;
          localStorage.setItem("cart_id", id);
        } catch (e1) {
          console.log(e1);
        }
      }
}

const minus = async (id, qty, index) => {
   // arrayQuantity is for set new cartId and reset cartItem when cartID change by customer in localStorage
  await addLocalStorageCartItem();
  if (qty > 1) {
    loading.value[index].minus = true;
    let x = qty - 1;
    try {
      await axios.patch(
        `https://parsinekala.com/backend/api/carts/${localStorage.getItem(
          "cart_id"
        )}/items/${id}/`,{ quantity: x });
      loading.value[index].minus = false;
      await addLocalStorageCartItem();
    } catch (e) {
      if (e.response.status == 404) {
            try {
              let req = await axios.post(
                "https://parsinekala.com/backend/api/carts/");
              let id = req.data.id;
              localStorage.setItem("cart_id", id);
              addLocalStorageCartItem();
            } catch (e) {
              // console.log(e);
            }
          }
      getNewCartId(e);

      loading.value[index].minus = false;

      // console.log(e);
    }
  }
 
  if (qty === 1) {

    loading.value[index].minus = true;
      console.log('qtyCart',id)
      try {
           await axios.delete(`https://parsinekala.com/backend/api/carts/${localStorage.getItem("cart_id")}/items/${id}/`);
        console.log('qtyCart2',id);
      await card_item.arrayQuantity();
       card_item.disableCardAddBtn();
       card_item.setRefreshWatch();

      } catch (error) {
              getNewCartId(error);
      }finally{
        loading.value[index].minus = false;
      }
  if(qty === 0) {
    loading.value[index].minus = true;
    try {
       await axios.delete(
        `https://parsinekala.com/backend/api/carts/${localStorage.getItem(
          "cart_id"
        )}/items/${id}/`);
      loading.value[index].minus = false;
     await addLocalStorageCartItem();

      card_item.disableCardAddBtn();
      card_item.setRefreshWatch();


    } catch (e) {
      getNewCartId(e);

      loading.value[index].minus = false;
      // console.log(e);
    }
  }
}
}



addLocalStorageCartItem()

const plus = async (id, qty, totalQty, index) => {
  // arrayQuantity is for set new cartId and reset cartItem when cartID change by customer in localStorage
  await addLocalStorageCartItem();
  if(totalQty > qty) {
    loading.value[index].plus = true;
    let x = qty + 1;
    try {
       await axios.patch( `https://parsinekala.com/backend/api/carts/${localStorage.getItem(
          "cart_id"
        )}/items/${id}/`,
        { quantity: x }
        
      );
      await addLocalStorageCartItem();
      loading.value[index].plus = false;
    } catch (e) {
      if (e.response.status == 404) {
            try {
              let req = await $fetch(
                "https://parsinekala.com/backend/api/carts/",{
                  method:'POST'
                }
              );
              let id = req.id;
              localStorage.setItem("cart_id", id);
              addLocalStorageCartItem();
            } catch (e) {
              // console.log(e);
            }
          }
      getNewCartId(e);
      loading.value[index].plus = false;
      // console.log(e);
    }
  }
};

</script>
